export const ERROR_MESSAGES = {
  LOAD: 'Failed to load custom field definitions',
  CREATE: 'Failed to create custom field definition',
  UPDATE: 'Failed to update custom field definition',
  DELETE: 'Failed to delete custom field definition',
};
